import type { User } from '@supabase/supabase-js'

/**
 * Admin is decided ONLY by `app_metadata.role`, which Supabase sets server-side and a user cannot
 * change. `user_metadata` is writable by the user themself (`auth.updateUser({ data: { role } })`)
 * and is copied into their JWT, so it must never grant a privilege; the top-level `role` claim is
 * the Postgres role ("authenticated") and is ignored too.
 */
export function isAdmin(user: Pick<User, 'app_metadata'> | null | undefined): boolean {
  if (!user) return false
  const meta: unknown = user.app_metadata
  if (!meta || typeof meta !== 'object' || Array.isArray(meta)) return false
  const role = (meta as Record<string, unknown>).role
  return role === 'admin' || role === 'super_admin'
}
